export enum CATEGORY_TYPE {
  catalog = 'CATALOG',
  product = 'PRODUCT',
}
